module.exports = __webpack_public_path__ + "img/guest.0e21ae37.svg";